import { refreshTokenIfNeeded } from "./auth";

export const createMiddleware = (actions) => {
  const middleware = (store) => (next) => (action) => {
    if (actions.includes(action.type)) {
      // Dispatch token refresh and then continue with original action
      return store
        .dispatch(refreshTokenIfNeeded())
        .then(() => next(action))
        .catch(() => next(action)); // Continue even if refresh fails to let original action handle auth errors
    }
    // For other actions, just continue normally
    return next(action);
  };
  return middleware;
};
